module.exports = __webpack_public_path__ + "static/media/check_empty.0ef972ea.png";